import React, { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { SupportRoutes, LocalAccountStorage, AppConfiguration } from "src/common";
import { Icon } from "src/components";

// NOTE: This link is conditional because web needs to respect CSP and main site cookies affect the scans
const support_link = AppConfiguration.buildForWeb() ? SupportRoutes.troubleshooting_preveil : SupportRoutes.preveil_support;
// Description: Support Dropdown
function SupportDropdown() {
  const [support_notification, setSupportNotification] = useState<string | null>(localStorage.getItem("support_notification"));
  const [show, setShow] = useState(false);

  return (
    <Dropdown className={`nav-item${!!support_notification ? "" : " dot"}`}
      show={show}
      onToggle={setShow}
      onClick={() => {
        setSupportNotification("true");
        LocalAccountStorage.setTemporaryCookies("support_notification", "true");
      }}>
      <Dropdown.Toggle as="a"
        aria-label="Customer Support"
        aria-haspopup="menu"
        aria-expanded={show}>
        <Icon className="ficon-help-circle show-desktop" />
        <span className="hide-desktop">Support</span>
      </Dropdown.Toggle>
      <Dropdown.Menu align="end">
        <Dropdown.Item target="_blank" aria-label="Help Center & Support"
          href={`${support_link}`} >
          Help Center
        </Dropdown.Item>
        <Dropdown.Item target="_blank" aria-label="Getting Started Support"
          href={`${SupportRoutes.getting_started}`}>
          Getting Started
        </Dropdown.Item>
        <Dropdown.Item target="_blank" aria-label="Using Drive Support"
          href={`${SupportRoutes.using_drive}`}>
          Using Drive
        </Dropdown.Item>
        <Dropdown.Item target="_blank" aria-label="Account & Recovery Settings Support"
          href={`${SupportRoutes.accounts_recovery_settings}`} >
          Account & Recovery Settings
        </Dropdown.Item>
        <Dropdown.Item target="_blank" aria-label="Security & Privacy Support"
          href={`${SupportRoutes.security_privacy}`} >
          Security & Privacy
        </Dropdown.Item>
        <Dropdown.Item target="_blank" aria-label="What's New with PreVeil"
          href={SupportRoutes.whats_new}>
          <Icon className="pv-icon-starred featured" />
          What's New with PreVeil
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default React.memo(SupportDropdown);
